import React from 'react';
import { Button, Box } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';

const GeneratingButton = ({
  isGenerating = false,
  onClick,
  text = '生成',
  generatingText = '正在生成...',
  sx = {},
  className,
  ...props
}) => {
  return (
    <Button
      className={className}
      variant="contained"
      color="primary"
      onClick={onClick}
      disabled={isGenerating}
      sx={{
        minHeight: 30,
        borderRadius: '8px',
        fontSize: '0.72rem',
        fontWeight: 700,
        textTransform: 'none',
        flex: 1,
        ...sx
      }}
      {...props}
    >
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: 'nowrap', // 🔥 防窄按钮时文字折行变形（移动端三等宽按钮场景）
      }}>
        <BoltIcon sx={{ mr: 0.5, fontSize: '14px' }} />
        {text}
      </Box>
    </Button>
  );
};

export default GeneratingButton;
